(ns frontend.ui.page.sub
  (:require
   [common.localization :as loc]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::accounts-by-id
 (fn [db _]
   (get db ::accounts-by-id)))
